export const getMetrics = state =>
  state && state.home && state.home.MetricsData;
export const getTestimonials = state =>
  state && state.home && state.home.Testimonials;
export const getEmpoweringCommunities = state =>
  state && state.home && state.home.EmpoweringCommunities;
